module.exports = __webpack_public_path__ + "img/figma.ad5d307e.svg";